"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Fields = require("./Fields");
Object.keys(_Fields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Fields[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Fields[key];
    }
  });
});